import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, of, ReplaySubject, Subject, takeUntil, tap } from 'rxjs';
import { ApplicationConfigService } from '../config/application-config.service';
import { ListenerService } from '../listener/listener.service';

@Injectable({ providedIn: 'root' })
export class NavigationService {
	private resourceUrl = this._applicationConfigService.getEndpointFor(
		'api/common/navigation',
		'vibraerpws'
	);
	private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
	private _navigationCache: Navigation = null;
	private _unsubscribeAll: Subject<any> = new Subject<any>();

	/**
	 * Constructor
	 */
	constructor(
		private _httpClient: HttpClient,
		private _applicationConfigService: ApplicationConfigService,
		private _listenerService: ListenerService
	) {
		this._listenerService
			.messageSystemNavigation()
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((data) => {
				if (data.action === 'reload') {
					this.reload();
				}
			});
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Accessors
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Getter for navigation
	 */
	get navigation$(): Observable<Navigation> {
		return this._navigation.asObservable();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Get all navigation data
	 */
	get(): Observable<Navigation> {
		if (this._navigationCache != null) {
			return of(this._navigationCache);
		}
		return this._httpClient
			.get<Navigation>(this.resourceUrl + '?sort=position&id.greaterThan=0&navigationId.equals=0')
			.pipe(
				tap((navigation: any) => {
					console.log(navigation);
					this._navigationCache = { default: navigation };
					this._navigation.next(this._navigationCache);
				})
			);
	}

	reset(): void {
		this._navigationCache = null;
	}

	reload(): void {
		this.reset();
		this.get().subscribe();
	}
}
